<!--
 * @Descripttion: 切换到工具新版
 * @Author: Niu Chenxin
 * @Date: 2021-01-22 16:19:22
 * @LastEditors: wei ze min
 * @LastEditTime: 2021-06-16 15:01:22
-->
<template>
  <div class='newTools'>
    <div class="logo">
      <img src="@/assets/images/logo.png" alt="">
    </div>

    <van-button type="info" @click="toNew">切换到喂养记录</van-button>
    <van-button plain type="info" @click="toOld">切换到现有版本</van-button>
  </div>
</template>

<script>
import { setCookie } from "@/assets/js/common.js";
export default {
  name: "newTools",
  methods: {
    toNew () {
      setCookie('isFeedTool', 'true');
      this.$toast({
        message: '即将自动跳转到星妈会首页',
        duration: 1500,
        onClose: function () {
          location.href = '/home';
        }
      })
    },
    toOld () {
      setCookie('isFeedTool', 'false');
      this.$toast({
        message: '即将自动跳转到星妈会首页',
        duration: 1500,
        onClose: function () {
          location.href = '/home';
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.newTools {
  position: fixed;
  width: 80%;
  padding: 0 10%;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  .logo {
    text-align: center;
    margin-bottom: 50px;
    img {
      display: inline-block;
      width: 110px;
    }
  }
  /deep/ .van-button--info {
    width: 100%;
    margin-bottom: 14px;
  }
}
</style>